import React, {useState} from "react";
import * as FeatherIcon from "react-feather";
import { COMPANY_LOGO_BASE_URL } from "../../../../../config/apiConfig";
import { displayFormattedDate } from "../../../../../services/commonService";
import PlainModal from "../../../../HtmlElements/PlainModal";


const NudgeCard = ({ nudge, handleSideCard, index, handleMore }) => {


  return (<div className="news_block">
    <div className="news_emoji_block">
      <div className="name_icon">
        {/* <div className="news_name_logo_block"> */}
          {/* <img
            src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(nudge?.account)}`}
            alt="icon"
            className="news_comp_logo"
          /> */}
          {/* <p className="news_comp_name">{nudge?.account}</p> */}
        {/* </div> */}

        <div className="d-flex">
          <div className="gray_tag_block">
            <p className="gray_tag_block_text">{nudge?.opportunity_category}</p>
          </div>
          {/* {nudge?.opportunity_type === "Positive" ? (
            <div className="positive_block">
              <p className="positive_text">
                <img src="/img/positive_frown.png" className="positive_icon" />
                {nudge?.opportunity_type}
              </p>
            </div>
          ) : (
            <div className="negative_block">
              <p className="negative_text">
                <img src="/img/negative_frown.png" className="negative_icon" />
                {nudge?.opportunity_type}
              </p>
            </div>
          )} */}
        </div>

        <div className="d-flex">
        {nudge?.opportunity_type === "Positive" ? (
            <div className="positive_block">
              <p className="positive_text">
                <img src="/img/positive_frown.png" className="positive_icon" />
                {nudge?.opportunity_type}
              </p>
            </div>
          ) : (nudge?.opportunity_type === "Neutral" ?
            (<div className="neutral_block">
            <p className="neutral_text">
              <img src="/img/neutral_frown.png" className="neutral_icon" />
              {nudge?.opportunity_type}
            </p>
          </div>) : (<div className="negative_block">
              <p className="negative_text">
                <img src="/img/negative_frown.png" className="negative_icon" />
                {nudge?.opportunity_type}
              </p>
            </div>)
          )}
        </div>
      </div>

      <div className="news_content">
        <h5 className="nes_content_head" 
        style={{textDecoration: 'none', cursor: 'text'}}
        // onClick={(e) => handleSideCard(e,nudge)}
          >
          {nudge?.opportunity_name}
        </h5>
        <p className="news_content_para pt-2">{nudge?.opportunity_description}</p>
        {
          nudge?.opportunity_description && (<p className='show_more pt-2' onClick={() => handleMore(index)}><i className="fa fa-ellipsis-h" aria-hidden="true"></i></p>)
        }
      </div>

      <div className="news_bottom_block d-flex justify-content-between">
        <div className="news_date_name_block d-flex">
          <p className="news_name">
            <a
              href={nudge?.event_link}
              target="_blank"
              rel="noopener noreferrer"
              className="email_link"
            >
              {/* <i className="fa fa-linkedin-square" aria-hidden="true"></i>{" "} */}
              {nudge?.opportunity_source}
            </a>
          </p>
          <p className="news_name px-2">|</p>
          <p className="news_name">
            <i>
              {
                nudge?.event_date && displayFormattedDate(
                nudge?.event_date,
                "YYYY-MM-DD",
                true)
              }
            </i>
          </p>
        </div>
        <div className="d-flex">
          {/* <div className="news_share_block"> <p className="news_share_text"> <FeatherIcon.Bookmark className="fa" /></p></div> */}
          {/* <div className="news_share_block"><p className="news_share_text"> <FeatherIcon.Share2 className="fa" /></p></div> */}
        </div>
      </div>
    </div>
  </div>)
}

export default NudgeCard;
